import { createMixpanelAnalyticsClient } from '@satellite/analytics/createMixpanelAnalyticsClient';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';
import { environment, mixpanelToken } from '@/config';

/** Builds the Mixpanel client Comet provides through `analyticsKey`. */
export function createCometAnalyticsClient(): AnalyticsClient {
  return createMixpanelAnalyticsClient({
    token: mixpanelToken,
    serverEnv: environment
  });
}
